// Category detection and color mapping for tennis tournaments.
// Ported from the mobile app's categoryUtils.ts.

export const CATEGORIES = {
  atp_singles: { key: "atp_singles", label: "ATP Singles", color: "#3b82f6", bgColor: "#3b82f615", icon: "sports", sortOrder: 0 },
  wta_singles: { key: "wta_singles", label: "WTA Singles", color: "#ec4899", bgColor: "#ec489915", icon: "sports", sortOrder: 1 },
  team_cup:    { key: "team_cup",    label: "Team Cups",   color: "#10b981", bgColor: "#10b98115", icon: "flag", sortOrder: 2 },
  atp_doubles: { key: "atp_doubles", label: "ATP Doubles", color: "#06b6d4", bgColor: "#06b6d415", icon: "people", sortOrder: 3 },
  wta_doubles: { key: "wta_doubles", label: "WTA Doubles", color: "#a855f7", bgColor: "#a855f715", icon: "people", sortOrder: 4 },
  challenger:  { key: "challenger",  label: "Challenger",  color: "#f59e0b", bgColor: "#f59e0b15", icon: "trophy", sortOrder: 5 },
  other:       { key: "other",       label: "Other",       color: "#6b7280", bgColor: "#6b728015", icon: "sports", sortOrder: 6 },
};

export function detectCategory(tournament, player1, player2) {
  const t = (tournament || "").toLowerCase();
  const p1 = player1 || "";
  const p2 = player2 || "";
  const isDoubles = p1.includes("/") || p2.includes("/") || t.includes("double");

  if (t.includes("challenger")) return CATEGORIES.challenger;
  if (t.includes("billie jean king") || t.includes("davis cup") || t.includes("united cup") || t.includes("laver cup") || t.includes("fed cup")) return CATEGORIES.team_cup;
  if (t.includes("atp") && !isDoubles) return CATEGORIES.atp_singles;
  if (t.includes("wta") && !isDoubles) return CATEGORIES.wta_singles;
  if (t.includes("atp") && isDoubles) return CATEGORIES.atp_doubles;
  if (t.includes("wta") && isDoubles) return CATEGORIES.wta_doubles;
  return CATEGORIES.other;
}

export function groupMatchesByCategory(matches) {
  const categoryMap = {};
  for (const match of matches) {
    const cat = detectCategory(match.tournament || "", match.player1, match.player2);
    if (!categoryMap[cat.key]) categoryMap[cat.key] = { category: cat, tournamentMap: {} };
    const tourney = match.tournament || "Unknown";
    if (!categoryMap[cat.key].tournamentMap[tourney]) categoryMap[cat.key].tournamentMap[tourney] = [];
    categoryMap[cat.key].tournamentMap[tourney].push(match);
  }
  return Object.values(categoryMap)
    .map(({ category, tournamentMap }) => ({
      category,
      tournaments: Object.entries(tournamentMap).map(([tournament, ms]) => ({ tournament, matches: ms })),
      totalMatches: Object.values(tournamentMap).reduce((s, a) => s + a.length, 0),
    }))
    .sort((a, b) => a.category.sortOrder - b.category.sortOrder);
}
